'use strict';

/**
 * DO NOT MODIFY
 * Generated from yarn nx run icons:sync
 */

/**
 * This file powers the icon font lookup on web and mobile.
 * In addition, this is used to populate the stories in percy, so the sort order based on createdAt is important.
 */
const glyphMap = {
  'nav-hiddenEye-12-active': '',
  'nav-hiddenEye-12-inactive': '',
  'nav-hiddenEye-16-active': '',
  'nav-hiddenEye-16-inactive': '',
  'nav-hiddenEye-24-active': '',
  'nav-hiddenEye-24-inactive': '',
  'nav-trading-12-active': '',
  'nav-trading-12-inactive': '',
  'nav-trading-16-active': '',
  'nav-trading-16-inactive': '',
  'nav-trading-24-active': '',
  'nav-trading-24-inactive': '',
  'nav-queryTransact-12-active': '',
  'nav-queryTransact-12-inactive': '',
  'nav-queryTransact-16-active': '',
  'nav-queryTransact-16-inactive': '',
  'nav-queryTransact-24-active': '',
  'nav-queryTransact-24-inactive': '',
  'nav-taxes-12-active': '',
  'nav-taxes-12-inactive': '',
  'nav-taxes-16-active': '',
  'nav-taxes-16-inactive': '',
  'nav-taxes-24-active': '',
  'nav-taxes-24-inactive': '',
  'nav-appSwitcher-12-active': '',
  'nav-appSwitcher-12-inactive': '',
  'nav-appSwitcher-16-active': '',
  'nav-appSwitcher-16-inactive': '',
  'nav-appSwitcher-24-active': '',
  'nav-appSwitcher-24-inactive': '',
  'nav-collection-12-active': '',
  'nav-collection-12-inactive': '',
  'nav-collection-16-active': '',
  'nav-collection-16-inactive': '',
  'nav-collection-24-active': '',
  'nav-collection-24-inactive': '',
  'nav-light-12-active': '',
  'nav-light-12-inactive': '',
  'nav-light-16-active': '',
  'nav-light-16-inactive': '',
  'nav-light-24-active': '',
  'nav-light-24-inactive': '',
  'nav-planet-12-active': '',
  'nav-planet-12-inactive': '',
  'nav-planet-16-active': '',
  'nav-planet-16-inactive': '',
  'nav-planet-24-active': '',
  'nav-planet-24-inactive': '',
  'nav-shoppingCart-12-active': '',
  'nav-shoppingCart-12-inactive': '',
  'nav-shoppingCart-16-active': '',
  'nav-shoppingCart-16-inactive': '',
  'nav-shoppingCart-24-active': '',
  'nav-shoppingCart-24-inactive': '',
  'nav-peopleGroup-12-active': '',
  'nav-peopleGroup-12-inactive': '',
  'nav-peopleGroup-16-active': '',
  'nav-peopleGroup-16-inactive': '',
  'nav-peopleGroup-24-active': '',
  'nav-peopleGroup-24-inactive': '',
  'nav-trophyCup-12-active': '',
  'nav-trophyCup-12-inactive': '',
  'nav-trophyCup-16-active': '',
  'nav-trophyCup-16-inactive': '',
  'nav-trophyCup-24-active': '',
  'nav-trophyCup-24-inactive': '',
  'nav-moreVertical-12-active': '',
  'nav-moreVertical-12-inactive': '',
  'nav-moreVertical-16-active': '',
  'nav-moreVertical-16-inactive': '',
  'nav-moreVertical-24-active': '',
  'nav-moreVertical-24-inactive': '',
  'nav-participate-12-active': '',
  'nav-participate-12-inactive': '',
  'nav-participate-16-active': '',
  'nav-participate-16-inactive': '',
  'nav-participate-24-active': '',
  'nav-participate-24-inactive': '',
  'nav-moon-12-active': '',
  'nav-moon-12-inactive': '',
  'nav-moon-16-active': '',
  'nav-moon-16-inactive': '',
  'nav-moon-24-active': '',
  'nav-moon-24-inactive': '',
  'nav-securityShield-12-active': '',
  'nav-securityShield-12-inactive': '',
  'nav-securityShield-16-active': '',
  'nav-securityShield-16-inactive': '',
  'nav-securityShield-24-active': '',
  'nav-securityShield-24-inactive': '',
  'nav-invoice-12-active': '',
  'nav-invoice-12-inactive': '',
  'nav-invoice-16-active': '',
  'nav-invoice-16-inactive': '',
  'nav-invoice-24-active': '',
  'nav-invoice-24-inactive': '',
  'nav-gab-12-active': '',
  'nav-gab-12-inactive': '',
  'nav-gab-16-active': '',
  'nav-gab-16-inactive': '',
  'nav-gab-24-active': '',
  'nav-gab-24-inactive': '',
  'nav-heart-12-active': '',
  'nav-heart-12-inactive': '',
  'nav-heart-16-active': '',
  'nav-heart-16-inactive': '',
  'nav-heart-24-active': '',
  'nav-heart-24-inactive': '',
  'nav-account-12-active': '',
  'nav-account-12-inactive': '',
  'nav-account-16-active': '',
  'nav-account-16-inactive': '',
  'nav-account-24-active': '',
  'nav-account-24-inactive': '',
  'nav-hammer-12-active': '',
  'nav-hammer-12-inactive': '',
  'nav-hammer-16-active': '',
  'nav-hammer-16-inactive': '',
  'nav-hammer-24-active': '',
  'nav-hammer-24-inactive': '',
  'nav-tag-12-active': '',
  'nav-tag-12-inactive': '',
  'nav-tag-16-active': '',
  'nav-tag-16-inactive': '',
  'nav-tag-24-active': '',
  'nav-tag-24-inactive': '',
  'nav-giftBox-12-active': '',
  'nav-giftBox-12-inactive': '',
  'nav-giftBox-16-active': '',
  'nav-giftBox-16-inactive': '',
  'nav-giftBox-24-active': '',
  'nav-giftBox-24-inactive': '',
  'nav-support-12-active': '',
  'nav-support-12-inactive': '',
  'nav-support-16-active': '',
  'nav-support-16-inactive': '',
  'nav-support-24-active': '',
  'nav-support-24-inactive': '',
  'nav-eye-12-active': '',
  'nav-eye-12-inactive': '',
  'nav-eye-16-active': '',
  'nav-eye-16-inactive': '',
  'nav-eye-24-active': '',
  'nav-eye-24-inactive': '',
  'nav-earn-12-active': '',
  'nav-earn-12-inactive': '',
  'nav-earn-16-active': '',
  'nav-earn-16-inactive': '',
  'nav-earn-24-active': '',
  'nav-earn-24-inactive': '',
  'nav-directDeposit-12-active': '',
  'nav-directDeposit-12-inactive': '',
  'nav-directDeposit-16-active': '',
  'nav-directDeposit-16-inactive': '',
  'nav-directDeposit-24-active': '',
  'nav-directDeposit-24-inactive': '',
  'nav-crystalBall-12-active': '',
  'nav-crystalBall-12-inactive': '',
  'nav-crystalBall-16-active': '',
  'nav-crystalBall-16-inactive': '',
  'nav-crystalBall-24-active': '',
  'nav-crystalBall-24-inactive': '',
  'nav-diamond-12-active': '',
  'nav-diamond-12-inactive': '',
  'nav-diamond-16-active': '',
  'nav-diamond-16-inactive': '',
  'nav-diamond-24-active': '',
  'nav-diamond-24-inactive': '',
  'nav-comment-12-active': '',
  'nav-comment-12-inactive': '',
  'nav-comment-16-active': '',
  'nav-comment-16-inactive': '',
  'nav-comment-24-active': '',
  'nav-comment-24-inactive': '',
  'nav-chartPie-12-active': '',
  'nav-chartPie-12-inactive': '',
  'nav-chartPie-16-active': '',
  'nav-chartPie-16-inactive': '',
  'nav-chartPie-24-active': '',
  'nav-chartPie-24-inactive': '',
  'nav-chartCandles-12-active': '',
  'nav-chartCandles-12-inactive': '',
  'nav-chartCandles-16-active': '',
  'nav-chartCandles-16-inactive': '',
  'nav-chartCandles-24-active': '',
  'nav-chartCandles-24-inactive': '',
  'nav-royalty-12-active': '',
  'nav-royalty-12-inactive': '',
  'nav-royalty-16-active': '',
  'nav-royalty-16-inactive': '',
  'nav-royalty-24-active': '',
  'nav-royalty-24-inactive': '',
  'nav-cash-12-active': '',
  'nav-cash-12-inactive': '',
  'nav-cash-16-active': '',
  'nav-cash-16-inactive': '',
  'nav-cash-24-active': '',
  'nav-cash-24-inactive': '',
  'nav-caret-12-active': '',
  'nav-caret-12-inactive': '',
  'nav-caret-16-active': '',
  'nav-caret-16-inactive': '',
  'nav-caret-24-active': '',
  'nav-caret-24-inactive': '',
  'nav-browser-12-active': '',
  'nav-browser-12-inactive': '',
  'nav-browser-16-active': '',
  'nav-browser-16-inactive': '',
  'nav-browser-24-active': '',
  'nav-browser-24-inactive': '',
  'nav-documentation-12-active': '',
  'nav-documentation-12-inactive': '',
  'nav-documentation-16-active': '',
  'nav-documentation-16-inactive': '',
  'nav-documentation-24-active': '',
  'nav-documentation-24-inactive': '',
  'nav-settings-12-active': '',
  'nav-settings-12-inactive': '',
  'nav-settings-16-active': '',
  'nav-settings-16-inactive': '',
  'nav-settings-24-active': '',
  'nav-settings-24-inactive': '',
  'nav-astronautHelmet-12-active': '',
  'nav-astronautHelmet-12-inactive': '',
  'nav-astronautHelmet-16-active': '',
  'nav-astronautHelmet-16-inactive': '',
  'nav-astronautHelmet-24-active': '',
  'nav-astronautHelmet-24-inactive': '',
  'nav-newsfeed-12-active': '',
  'nav-newsfeed-12-inactive': '',
  'nav-newsfeed-16-active': '',
  'nav-newsfeed-16-inactive': '',
  'nav-newsfeed-24-active': '',
  'nav-newsfeed-24-inactive': '',
  'nav-home-12-active': '',
  'nav-home-12-inactive': '',
  'nav-home-16-active': '',
  'nav-home-16-inactive': '',
  'nav-home-24-active': '',
  'nav-home-24-inactive': '',
  'nav-sun-12-active': '',
  'nav-sun-12-inactive': '',
  'nav-sun-16-active': '',
  'nav-sun-16-inactive': '',
  'nav-sun-24-active': '',
  'nav-sun-24-inactive': '',
  'nav-pay-12-active': '',
  'nav-pay-12-inactive': '',
  'nav-pay-16-active': '',
  'nav-pay-16-inactive': '',
  'nav-pay-24-active': '',
  'nav-pay-24-inactive': '',
  'nav-defi-12-active': '',
  'nav-defi-12-inactive': '',
  'nav-defi-16-active': '',
  'nav-defi-16-inactive': '',
  'nav-defi-24-active': '',
  'nav-defi-24-inactive': '',
  'nav-paymentCard-12-active': '',
  'nav-paymentCard-12-inactive': '',
  'nav-paymentCard-16-active': '',
  'nav-paymentCard-16-inactive': '',
  'nav-paymentCard-24-active': '',
  'nav-paymentCard-24-inactive': '',
  'nav-scanQrCode-12-active': '',
  'nav-scanQrCode-12-inactive': '',
  'nav-scanQrCode-16-active': '',
  'nav-scanQrCode-16-inactive': '',
  'nav-scanQrCode-24-active': '',
  'nav-scanQrCode-24-inactive': '',
  'nav-pencil-12-active': '',
  'nav-pencil-12-inactive': '',
  'nav-pencil-16-active': '',
  'nav-pencil-16-inactive': '',
  'nav-pencil-24-active': '',
  'nav-pencil-24-inactive': '',
  'nav-cloud-12-active': '',
  'nav-cloud-12-inactive': '',
  'nav-cloud-16-active': '',
  'nav-cloud-16-inactive': '',
  'nav-cloud-24-active': '',
  'nav-cloud-24-inactive': '',
  'nav-bell-12-active': '',
  'nav-bell-12-inactive': '',
  'nav-bell-16-active': '',
  'nav-bell-16-inactive': '',
  'nav-bell-24-active': '',
  'nav-bell-24-inactive': '',
  'nav-interest-12-active': '',
  'nav-interest-12-inactive': '',
  'nav-interest-16-active': '',
  'nav-interest-16-inactive': '',
  'nav-interest-24-active': '',
  'nav-interest-24-inactive': '',
  'nav-chartBar-12-active': '',
  'nav-chartBar-12-inactive': '',
  'nav-chartBar-16-active': '',
  'nav-chartBar-16-inactive': '',
  'nav-chartBar-24-active': '',
  'nav-chartBar-24-inactive': '',
  'nav-faces-12-active': '',
  'nav-faces-12-inactive': '',
  'nav-faces-16-active': '',
  'nav-faces-16-inactive': '',
  'nav-faces-24-active': '',
  'nav-faces-24-inactive': '',
  'nav-dashboard-12-active': '',
  'nav-dashboard-12-inactive': '',
  'nav-dashboard-16-active': '',
  'nav-dashboard-16-inactive': '',
  'nav-dashboard-24-active': '',
  'nav-dashboard-24-inactive': '',
  'nav-application-12-active': '',
  'nav-application-12-inactive': '',
  'nav-application-16-active': '',
  'nav-application-16-inactive': '',
  'nav-application-24-active': '',
  'nav-application-24-inactive': '',
  'nav-addPeople-12-active': '',
  'nav-addPeople-12-inactive': '',
  'nav-addPeople-16-active': '',
  'nav-addPeople-16-inactive': '',
  'nav-addPeople-24-active': '',
  'nav-addPeople-24-inactive': '',
  'nav-ghost-12-active': '',
  'nav-ghost-12-inactive': '',
  'nav-ghost-16-active': '',
  'nav-ghost-16-inactive': '',
  'nav-ghost-24-active': '',
  'nav-ghost-24-inactive': '',
  'nav-activity-12-active': '',
  'nav-activity-12-inactive': '',
  'nav-activity-16-active': '',
  'nav-activity-16-inactive': '',
  'nav-activity-24-active': '',
  'nav-activity-24-inactive': '',
  'nav-drops-12-active': '',
  'nav-drops-12-inactive': '',
  'nav-drops-16-active': '',
  'nav-drops-16-inactive': '',
  'nav-drops-24-active': '',
  'nav-drops-24-inactive': '',
  'nav-copy-12-active': '',
  'nav-copy-12-inactive': '',
  'nav-copy-16-active': '',
  'nav-copy-16-inactive': '',
  'nav-copy-24-active': '',
  'nav-copy-24-inactive': '',
  'nav-magnifyingGlass-12-active': '',
  'nav-magnifyingGlass-12-inactive': '',
  'nav-magnifyingGlass-16-active': '',
  'nav-magnifyingGlass-16-inactive': '',
  'nav-magnifyingGlass-24-active': '',
  'nav-magnifyingGlass-24-inactive': '',
  'nav-menu-12-active': '',
  'nav-menu-12-inactive': '',
  'nav-menu-16-active': '',
  'nav-menu-16-inactive': '',
  'nav-menu-24-active': '',
  'nav-menu-24-inactive': '',
  'nav-wallet-12-active': '',
  'nav-wallet-12-inactive': '',
  'nav-wallet-16-active': '',
  'nav-wallet-16-inactive': '',
  'nav-wallet-24-active': '',
  'nav-wallet-24-inactive': '',
  'nav-rocketShip-12-active': '',
  'nav-rocketShip-12-inactive': '',
  'nav-rocketShip-16-active': '',
  'nav-rocketShip-16-inactive': '',
  'nav-rocketShip-24-active': '',
  'nav-rocketShip-24-inactive': '',
  'ui-wrapToken-12': '',
  'ui-wrapToken-16': '',
  'ui-wrapToken-24': '',
  'ui-setPinCode-12': '',
  'ui-setPinCode-16': '',
  'ui-setPinCode-24': '',
  'ui-orderHistory-12': '',
  'ui-orderHistory-16': '',
  'ui-orderHistory-24': '',
  'ui-collapse-12': '',
  'ui-collapse-16': '',
  'ui-collapse-24': '',
  'ui-verticalLine-12': '',
  'ui-verticalLine-16': '',
  'ui-verticalLine-24': '',
  'ui-calendar-12': '',
  'ui-calendar-16': '',
  'ui-calendar-24': '',
  'ui-withdraw-12': '',
  'ui-withdraw-16': '',
  'ui-withdraw-24': '',
  'ui-chartPieCircle-12': '',
  'ui-chartPieCircle-16': '',
  'ui-chartPieCircle-24': '',
  'ui-arrowDown-12': '',
  'ui-arrowDown-16': '',
  'ui-arrowDown-24': '',
  'ui-cashRupee-12': '',
  'ui-cashRupee-16': '',
  'ui-cashRupee-24': '',
  'ui-book-12': '',
  'ui-book-16': '',
  'ui-book-24': '',
  'ui-minus-12': '',
  'ui-minus-16': '',
  'ui-minus-24': '',
  'ui-blog-12': '',
  'ui-blog-16': '',
  'ui-blog-24': '',
  'ui-cryptobasics-12': '',
  'ui-cryptobasics-16': '',
  'ui-cryptobasics-24': '',
  'ui-megaphone-12': '',
  'ui-megaphone-16': '',
  'ui-megaphone-24': '',
  'ui-lightbulb-12': '',
  'ui-lightbulb-16': '',
  'ui-lightbulb-24': '',
  'ui-pFPS-12': '',
  'ui-pFPS-16': '',
  'ui-pFPS-24': '',
  'ui-refresh-12': '',
  'ui-refresh-16': '',
  'ui-refresh-24': '',
  'ui-search-12': '',
  'ui-search-16': '',
  'ui-search-24': '',
  'ui-wireTransfer-12': '',
  'ui-wireTransfer-16': '',
  'ui-wireTransfer-24': '',
  'ui-wallet-12': '',
  'ui-wallet-16': '',
  'ui-wallet-24': '',
  'ui-visibleInactive-12': '',
  'ui-visibleInactive-16': '',
  'ui-visibleInactive-24': '',
  'ui-visibleActive-12': '',
  'ui-visibleActive-16': '',
  'ui-visibleActive-24': '',
  'ui-recurring-12': '',
  'ui-recurring-16': '',
  'ui-recurring-24': '',
  'ui-upload-12': '',
  'ui-upload-16': '',
  'ui-upload-24': '',
  'ui-unknown-12': '',
  'ui-unknown-16': '',
  'ui-unknown-24': '',
  'ui-trashCan-12': '',
  'ui-trashCan-16': '',
  'ui-trashCan-24': '',
  'ui-thumbsUpOutline-12': '',
  'ui-thumbsUpOutline-16': '',
  'ui-thumbsUpOutline-24': '',
  'ui-thumbsDown-12': '',
  'ui-thumbsDown-16': '',
  'ui-thumbsDown-24': '',
  'ui-taxesReceipt-12': '',
  'ui-taxesReceipt-16': '',
  'ui-taxesReceipt-24': '',
  'ui-step7-12': '',
  'ui-step7-16': '',
  'ui-step7-24': '',
  'ui-step5-12': '',
  'ui-step5-16': '',
  'ui-step5-24': '',
  'ui-step4-12': '',
  'ui-step4-16': '',
  'ui-step4-24': '',
  'ui-step3-12': '',
  'ui-step3-16': '',
  'ui-step3-24': '',
  'ui-step2-12': '',
  'ui-step2-16': '',
  'ui-step2-24': '',
  'ui-newsletter-12': '',
  'ui-newsletter-16': '',
  'ui-newsletter-24': '',
  'ui-step1-12': '',
  'ui-step1-16': '',
  'ui-step1-24': '',
  'ui-step0-12': '',
  'ui-step0-16': '',
  'ui-step0-24': '',
  'ui-starActive-12': '',
  'ui-starActive-16': '',
  'ui-starActive-24': '',
  'ui-sparkle-12': '',
  'ui-sparkle-16': '',
  'ui-sparkle-24': '',
  'ui-soundOn-12': '',
  'ui-soundOn-16': '',
  'ui-soundOn-24': '',
  'ui-cashBrazillianReal-12': '',
  'ui-cashBrazillianReal-16': '',
  'ui-cashBrazillianReal-24': '',
  'ui-soundOff-12': '',
  'ui-soundOff-16': '',
  'ui-soundOff-24': '',
  'ui-institute-12': '',
  'ui-institute-16': '',
  'ui-institute-24': '',
  'ui-sortUpCenter-12': '',
  'ui-sortUpCenter-16': '',
  'ui-sortUpCenter-24': '',
  'ui-sortUp-12': '',
  'ui-sortUp-16': '',
  'ui-sortUp-24': '',
  'ui-sortDownCenter-12': '',
  'ui-sortDownCenter-16': '',
  'ui-sortDownCenter-24': '',
  'ui-sortDown-12': '',
  'ui-sortDown-16': '',
  'ui-sortDown-24': '',
  'ui-sofort-12': '',
  'ui-sofort-16': '',
  'ui-sofort-24': '',
  'ui-smartContract-12': '',
  'ui-smartContract-16': '',
  'ui-smartContract-24': '',
  'ui-shield-12': '',
  'ui-shield-16': '',
  'ui-shield-24': '',
  'ui-payouts-12': '',
  'ui-payouts-16': '',
  'ui-payouts-24': '',
  'ui-share-12': '',
  'ui-share-16': '',
  'ui-share-24': '',
  'ui-globe-12': '',
  'ui-globe-16': '',
  'ui-globe-24': '',
  'ui-save-12': '',
  'ui-save-16': '',
  'ui-save-24': '',
  'ui-qrCodeAlt-12': '',
  'ui-qrCodeAlt-16': '',
  'ui-qrCodeAlt-24': '',
  'ui-safe-12': '',
  'ui-safe-16': '',
  'ui-safe-24': '',
  'ui-royaltyInactive-12': '',
  'ui-royaltyInactive-16': '',
  'ui-royaltyInactive-24': '',
  'ui-royaltyActive-12': '',
  'ui-royaltyActive-16': '',
  'ui-royaltyActive-24': '',
  'ui-reportActive-12': '',
  'ui-reportActive-16': '',
  'ui-reportActive-24': '',
  'ui-rectangle-12': '',
  'ui-rectangle-16': '',
  'ui-rectangle-24': '',
  'ui-reCenter-12': '',
  'ui-reCenter-16': '',
  'ui-reCenter-24': '',
  'ui-qrCode-12': '',
  'ui-qrCode-16': '',
  'ui-qrCode-24': '',
  'ui-pulse-12': '',
  'ui-pulse-16': '',
  'ui-pulse-24': '',
  'ui-play-12': '',
  'ui-play-16': '',
  'ui-play-24': '',
  'ui-pin-12': '',
  'ui-pin-16': '',
  'ui-pin-24': '',
  'ui-phone-12': '',
  'ui-phone-16': '',
  'ui-phone-24': '',
  'ui-percentage-12': '',
  'ui-percentage-16': '',
  'ui-percentage-24': '',
  'ui-pencil-12': '',
  'ui-pencil-16': '',
  'ui-pencil-24': '',
  'ui-paypal-12': '',
  'ui-paypal-16': '',
  'ui-paypal-24': '',
  'ui-pay-12': '',
  'ui-pay-16': '',
  'ui-pay-24': '',
  'ui-paperclip-12': '',
  'ui-paperclip-16': '',
  'ui-paperclip-24': '',
  'ui-paperAirplane-12': '',
  'ui-paperAirplane-16': '',
  'ui-paperAirplane-24': '',
  'ui-ultility-12': '',
  'ui-ultility-16': '',
  'ui-ultility-24': '',
  'ui-outline-12': '',
  'ui-outline-16': '',
  'ui-outline-24': '',
  'ui-trophy-12': '',
  'ui-trophy-16': '',
  'ui-trophy-24': '',
  'ui-noWifi-12': '',
  'ui-noWifi-16': '',
  'ui-noWifi-24': '',
  'ui-bell-12': '',
  'ui-bell-16': '',
  'ui-bell-24': '',
  'ui-nftSaleActive-12': '',
  'ui-nftSaleActive-16': '',
  'ui-nftSaleActive-24': '',
  'ui-affiliates-12': '',
  'ui-affiliates-16': '',
  'ui-affiliates-24': '',
  'ui-nftOfferActive-12': '',
  'ui-nftOfferActive-16': '',
  'ui-nftOfferActive-24': '',
  'ui-newsFeed-12': '',
  'ui-newsFeed-16': '',
  'ui-newsFeed-24': '',
  'ui-step8-12': '',
  'ui-step8-16': '',
  'ui-step8-24': '',
  'ui-externalLink-12': '',
  'ui-externalLink-16': '',
  'ui-externalLink-24': '',
  'ui-music-12': '',
  'ui-music-16': '',
  'ui-music-24': '',
  'ui-step6-12': '',
  'ui-step6-16': '',
  'ui-step6-24': '',
  'ui-metaverse-12': '',
  'ui-metaverse-16': '',
  'ui-metaverse-24': '',
  'ui-marketCap-12': '',
  'ui-marketCap-16': '',
  'ui-marketCap-24': '',
  'ui-fib-12': '',
  'ui-fib-16': '',
  'ui-fib-24': '',
  'ui-annotation-12': '',
  'ui-annotation-16': '',
  'ui-annotation-24': '',
  'ui-list-12': '',
  'ui-list-16': '',
  'ui-list-24': '',
  'ui-laptop-12': '',
  'ui-laptop-16': '',
  'ui-laptop-24': '',
  'ui-home-12': '',
  'ui-home-16': '',
  'ui-home-24': '',
  'ui-hammerInactive-12': '',
  'ui-hammerInactive-16': '',
  'ui-hammerInactive-24': '',
  'ui-chartVolume-12': '',
  'ui-chartVolume-16': '',
  'ui-chartVolume-24': '',
  'ui-doubleChevronRight-12': '',
  'ui-doubleChevronRight-16': '',
  'ui-doubleChevronRight-24': '',
  'ui-giftBox-12': '',
  'ui-giftBox-16': '',
  'ui-giftBox-24': '',
  'ui-error-12': '',
  'ui-error-16': '',
  'ui-error-24': '',
  'ui-games-12': '',
  'ui-games-16': '',
  'ui-games-24': '',
  'ui-followInactive-12': '',
  'ui-followInactive-16': '',
  'ui-followInactive-24': '',
  'ui-giftCard-12': '',
  'ui-giftCard-16': '',
  'ui-giftCard-24': '',
  'ui-followActive-12': '',
  'ui-followActive-16': '',
  'ui-followActive-24': '',
  'ui-twitterLogo-12': '',
  'ui-twitterLogo-16': '',
  'ui-twitterLogo-24': '',
  'ui-ghostInactive-12': '',
  'ui-ghostInactive-16': '',
  'ui-ghostInactive-24': '',
  'ui-fingerprint-12': '',
  'ui-fingerprint-16': '',
  'ui-fingerprint-24': '',
  'ui-faucetActive-12': '',
  'ui-faucetActive-16': '',
  'ui-faucetActive-24': '',
  'ui-nft-12': '',
  'ui-nft-16': '',
  'ui-nft-24': '',
  'ui-collectibles-12': '',
  'ui-collectibles-16': '',
  'ui-collectibles-24': '',
  'ui-faucetInactive-12': '',
  'ui-faucetInactive-16': '',
  'ui-faucetInactive-24': '',
  'ui-gauge-12': '',
  'ui-gauge-16': '',
  'ui-gauge-24': '',
  'ui-undo-12': '',
  'ui-undo-16': '',
  'ui-undo-24': '',
  'ui-cashThaiBaht-12': '',
  'ui-cashThaiBaht-16': '',
  'ui-cashThaiBaht-24': '',
  'ui-faceScan-12': '',
  'ui-faceScan-16': '',
  'ui-faceScan-24': '',
  'ui-cashPolishZloty-12': '',
  'ui-cashPolishZloty-16': '',
  'ui-cashPolishZloty-24': '',
  'ui-fork-12': '',
  'ui-fork-16': '',
  'ui-fork-24': '',
  'ui-horizontalLine-12': '',
  'ui-horizontalLine-16': '',
  'ui-horizontalLine-24': '',
  'ui-forwardArrow-12': '',
  'ui-forwardArrow-16': '',
  'ui-forwardArrow-24': '',
  'ui-more-12': '',
  'ui-more-16': '',
  'ui-more-24': '',
  'ui-deposit-12': '',
  'ui-deposit-16': '',
  'ui-deposit-24': '',
  'ui-expandAddress-12': '',
  'ui-expandAddress-16': '',
  'ui-expandAddress-24': '',
  'ui-gear-12': '',
  'ui-gear-16': '',
  'ui-gear-24': '',
  'ui-expand-12': '',
  'ui-expand-16': '',
  'ui-expand-24': '',
  'ui-exclamationMark-12': '',
  'ui-exclamationMark-16': '',
  'ui-exclamationMark-24': '',
  'ui-ethereum-12': '',
  'ui-ethereum-16': '',
  'ui-ethereum-24': '',
  'ui-diamondActive-12': '',
  'ui-diamondActive-16': '',
  'ui-diamondActive-24': '',
  'ui-hamburger-12': '',
  'ui-hamburger-16': '',
  'ui-hamburger-24': '',
  'ui-email-12': '',
  'ui-email-16': '',
  'ui-email-24': '',
  'ui-taxesReceiptInactive-12': '',
  'ui-taxesReceiptInactive-16': '',
  'ui-taxesReceiptInactive-24': '',
  'ui-bookmarkActive-12': '',
  'ui-bookmarkActive-16': '',
  'ui-bookmarkActive-24': '',
  'ui-keyboard-12': '',
  'ui-keyboard-16': '',
  'ui-keyboard-24': '',
  'ui-bookmarkInactive-12': '',
  'ui-bookmarkInactive-16': '',
  'ui-bookmarkInactive-24': '',
  'ui-dropsInactive-12': '',
  'ui-dropsInactive-16': '',
  'ui-dropsInactive-24': '',
  'ui-protection-12': '',
  'ui-protection-16': '',
  'ui-protection-24': '',
  'ui-expandAll-12': '',
  'ui-expandAll-16': '',
  'ui-expandAll-24': '',
  'ui-identityCard-12': '',
  'ui-identityCard-16': '',
  'ui-identityCard-24': '',
  'ui-info-12': '',
  'ui-info-16': '',
  'ui-info-24': '',
  'ui-downArrow-12': '',
  'ui-downArrow-16': '',
  'ui-downArrow-24': '',
  'ui-dot-12': '',
  'ui-dot-16': '',
  'ui-dot-24': '',
  'ui-document-12': '',
  'ui-document-16': '',
  'ui-document-24': '',
  'ui-diamondInactive-12': '',
  'ui-diamondInactive-16': '',
  'ui-diamondInactive-24': '',
  'ui-diagonalRightArrow-12': '',
  'ui-diagonalRightArrow-16': '',
  'ui-diagonalRightArrow-24': '',
  'ui-group-12': '',
  'ui-group-16': '',
  'ui-group-24': '',
  'ui-cashUSD-12': '',
  'ui-cashUSD-16': '',
  'ui-cashUSD-24': '',
  'ui-diagonalUpArrow-12': '',
  'ui-diagonalUpArrow-16': '',
  'ui-diagonalUpArrow-24': '',
  'ui-rocket-12': '',
  'ui-rocket-16': '',
  'ui-rocket-24': '',
  'ui-thumbsDownOutline-12': '',
  'ui-thumbsDownOutline-16': '',
  'ui-thumbsDownOutline-24': '',
  'ui-flame-12': '',
  'ui-flame-16': '',
  'ui-flame-24': '',
  'ui-defi-12': '',
  'ui-defi-16': '',
  'ui-defi-24': '',
  'ui-currencies-12': '',
  'ui-currencies-16': '',
  'ui-currencies-24': '',
  'ui-crossTrade-12': '',
  'ui-crossTrade-16': '',
  'ui-crossTrade-24': '',
  'ui-stake-12': '',
  'ui-stake-16': '',
  'ui-stake-24': '',
  'ui-heartActive-12': '',
  'ui-heartActive-16': '',
  'ui-heartActive-24': '',
  'ui-copy-12': '',
  'ui-copy-16': '',
  'ui-copy-24': '',
  'ui-profile-12': '',
  'ui-profile-16': '',
  'ui-profile-24': '',
  'ui-convert-12': '',
  'ui-convert-16': '',
  'ui-convert-24': '',
  'ui-commentActive-12': '',
  'ui-commentActive-16': '',
  'ui-commentActive-24': '',
  'ui-closeCaption-12': '',
  'ui-closeCaption-16': '',
  'ui-closeCaption-24': '',
  'ui-statusDot-12': '',
  'ui-statusDot-16': '',
  'ui-statusDot-24': '',
  'ui-clockOutline-12': '',
  'ui-clockOutline-16': '',
  'ui-clockOutline-24': '',
  'ui-gavel-12': '',
  'ui-gavel-16': '',
  'ui-gavel-24': '',
  'ui-clipboard-12': '',
  'ui-clipboard-16': '',
  'ui-clipboard-24': '',
  'ui-circleCross-12': '',
  'ui-circleCross-16': '',
  'ui-circleCross-24': '',
  'ui-circleCheckmark-12': '',
  'ui-circleCheckmark-16': '',
  'ui-circleCheckmark-24': '',
  'ui-checkmark-12': '',
  'ui-checkmark-16': '',
  'ui-checkmark-24': '',
  'ui-checkboxEmpty-12': '',
  'ui-checkboxEmpty-16': '',
  'ui-checkboxEmpty-24': '',
  'ui-directDepositIconInactive-12': '',
  'ui-directDepositIconInactive-16': '',
  'ui-directDepositIconInactive-24': '',
  'ui-cash-12': '',
  'ui-cash-16': '',
  'ui-cash-24': '',
  'ui-checkboxChecked-12': '',
  'ui-checkboxChecked-16': '',
  'ui-checkboxChecked-24': '',
  'ui-pyramid-12': '',
  'ui-pyramid-16': '',
  'ui-pyramid-24': '',
  'ui-chatBubble-12': '',
  'ui-chatBubble-16': '',
  'ui-chatBubble-24': '',
  'ui-chatBotAgent-12': '',
  'ui-chatBotAgent-16': '',
  'ui-chatBotAgent-24': '',
  'ui-chartPie-12': '',
  'ui-chartPie-16': '',
  'ui-chartPie-24': '',
  'ui-chartCandles-12': '',
  'ui-chartCandles-16': '',
  'ui-chartCandles-24': '',
  'ui-initiator-12': '',
  'ui-initiator-16': '',
  'ui-initiator-24': '',
  'ui-chartBar-12': '',
  'ui-chartBar-16': '',
  'ui-chartBar-24': '',
  'ui-add-12': '',
  'ui-add-16': '',
  'ui-add-24': '',
  'ui-cashVietnameseDong-12': '',
  'ui-cashVietnameseDong-16': '',
  'ui-cashVietnameseDong-24': '',
  'ui-heartInactive-12': '',
  'ui-heartInactive-16': '',
  'ui-heartInactive-24': '',
  'ui-cashUaeDirham-12': '',
  'ui-cashUaeDirham-16': '',
  'ui-cashUaeDirham-24': '',
  'ui-cashTurkishLira-12': '',
  'ui-cashTurkishLira-16': '',
  'ui-cashTurkishLira-24': '',
  'ui-cashSwissFranc-12': '',
  'ui-cashSwissFranc-16': '',
  'ui-cashSwissFranc-24': '',
  'ui-cashEUR-12': '',
  'ui-cashEUR-16': '',
  'ui-cashEUR-24': '',
  'ui-generalCharacter-12': '',
  'ui-generalCharacter-16': '',
  'ui-generalCharacter-24': '',
  'ui-cashPhilippinePeso-12': '',
  'ui-cashPhilippinePeso-16': '',
  'ui-cashPhilippinePeso-24': '',
  'ui-cashGBP-12': '',
  'ui-cashGBP-16': '',
  'ui-cashGBP-24': '',
  'ui-chainLink-12': '',
  'ui-chainLink-16': '',
  'ui-chainLink-24': '',
  'ui-cashBrazilianReal-12': '',
  'ui-cashBrazilianReal-16': '',
  'ui-cashBrazilianReal-24': '',
  'ui-ghostActive-12': '',
  'ui-ghostActive-16': '',
  'ui-ghostActive-24': '',
  'ui-visibleFilled-12': '',
  'ui-visibleFilled-16': '',
  'ui-visibleFilled-24': '',
  'ui-caretDown-12': '',
  'ui-caretDown-16': '',
  'ui-caretDown-24': '',
  'ui-seenActive-12': '',
  'ui-seenActive-16': '',
  'ui-seenActive-24': '',
  'ui-nftBuyActive-12': '',
  'ui-nftBuyActive-16': '',
  'ui-nftBuyActive-24': '',
  'ui-backArrow-12': '',
  'ui-backArrow-16': '',
  'ui-backArrow-24': '',
  'ui-average-12': '',
  'ui-average-16': '',
  'ui-average-24': '',
  'ui-wifi-12': '',
  'ui-wifi-16': '',
  'ui-wifi-24': '',
  'ui-arrowsVertical-12': '',
  'ui-arrowsVertical-16': '',
  'ui-arrowsVertical-24': '',
  'ui-discordLogo-12': '',
  'ui-discordLogo-16': '',
  'ui-discordLogo-24': '',
  'ui-artwork-12': '',
  'ui-artwork-16': '',
  'ui-artwork-24': '',
  'ui-directDepositIconActive-12': '',
  'ui-directDepositIconActive-16': '',
  'ui-directDepositIconActive-24': '',
  'ui-lightningBolt-12': '',
  'ui-lightningBolt-16': '',
  'ui-lightningBolt-24': '',
  'ui-api-12': '',
  'ui-api-16': '',
  'ui-api-24': '',
  'ui-arrowRight-12': '',
  'ui-arrowRight-16': '',
  'ui-arrowRight-24': '',
  'ui-airdrop-12': '',
  'ui-airdrop-16': '',
  'ui-airdrop-24': '',
  'ui-card-12': '',
  'ui-card-16': '',
  'ui-card-24': '',
  'ui-nftBuyInactive-12': '',
  'ui-nftBuyInactive-16': '',
  'ui-nftBuyInactive-24': '',
  'ui-bank-12': '',
  'ui-bank-16': '',
  'ui-bank-24': '',
  'ui-step9-12': '',
  'ui-step9-16': '',
  'ui-step9-24': '',
  'ui-instagramLogo-12': '',
  'ui-instagramLogo-16': '',
  'ui-instagramLogo-24': '',
  'ui-drag-12': '',
  'ui-drag-16': '',
  'ui-drag-24': '',
  'ui-avatar-12': '',
  'ui-avatar-16': '',
  'ui-avatar-24': '',
  'ui-thumbsUp-12': '',
  'ui-thumbsUp-16': '',
  'ui-thumbsUp-24': '',
  'ui-regulated-12': '',
  'ui-regulated-16': '',
  'ui-regulated-24': '',
  'ui-lock-12': '',
  'ui-lock-16': '',
  'ui-lock-24': '',
  'ui-arrowLeft-12': '',
  'ui-arrowLeft-16': '',
  'ui-arrowLeft-24': '',
  'ui-clock-12': '',
  'ui-clock-16': '',
  'ui-clock-24': '',
  'ui-nftOfferInactive-12': '',
  'ui-nftOfferInactive-16': '',
  'ui-nftOfferInactive-24': '',
  'ui-blockchain-12': '',
  'ui-blockchain-16': '',
  'ui-blockchain-24': '',
  'ui-telephone-12': '',
  'ui-telephone-16': '',
  'ui-telephone-24': '',
  'ui-transactions-12': '',
  'ui-transactions-16': '',
  'ui-transactions-24': '',
  'ui-diagonalDownArrow-12': '',
  'ui-diagonalDownArrow-16': '',
  'ui-diagonalDownArrow-24': '',
  'ui-starInactive-12': '',
  'ui-starInactive-16': '',
  'ui-starInactive-24': '',
  'ui-caretUp-12': '',
  'ui-caretUp-16': '',
  'ui-caretUp-24': '',
  'ui-download-12': '',
  'ui-download-16': '',
  'ui-download-24': '',
  'ui-arrowUp-12': '',
  'ui-arrowUp-16': '',
  'ui-arrowUp-24': '',
  'ui-warning-12': '',
  'ui-warning-16': '',
  'ui-warning-24': '',
  'ui-continuous-12': '',
  'ui-continuous-16': '',
  'ui-continuous-24': '',
  'ui-upArrow-12': '',
  'ui-upArrow-16': '',
  'ui-upArrow-24': '',
  'ui-questionMark-12': '',
  'ui-questionMark-16': '',
  'ui-questionMark-24': '',
  'ui-filter-12': '',
  'ui-filter-16': '',
  'ui-filter-24': '',
  'ui-allTimeHigh-12': '',
  'ui-allTimeHigh-16': '',
  'ui-allTimeHigh-24': '',
  'ui-close-12': '',
  'ui-close-16': '',
  'ui-close-24': '',
  'ui-caretLeft-12': '',
  'ui-caretLeft-16': '',
  'ui-caretLeft-24': '',
  'ui-dex-12': '',
  'ui-dex-16': '',
  'ui-dex-24': '',
  'ui-briefcase-12': '',
  'ui-briefcase-16': '',
  'ui-briefcase-24': '',
  'ui-pause-12': '',
  'ui-pause-16': '',
  'ui-pause-24': '',
  'ui-dropsActive-12': '',
  'ui-dropsActive-16': '',
  'ui-dropsActive-24': '',
  'ui-ideal-12': '',
  'ui-ideal-16': '',
  'ui-ideal-24': '',
  'ui-cashIndonesianRupiah-12': '',
  'ui-cashIndonesianRupiah-16': '',
  'ui-cashIndonesianRupiah-24': '',
  'ui-caretRight-12': '',
  'ui-caretRight-16': '',
  'ui-caretRight-24': '',
  'ui-arrowsHorizontal-12': '',
  'ui-arrowsHorizontal-16': '',
  'ui-arrowsHorizontal-24': '',
  'ui-hammerActive-12': '',
  'ui-hammerActive-16': '',
  'ui-hammerActive-24': '',
  'ui-speaker-12': '',
  'ui-speaker-16': '',
  'ui-speaker-24': '',
  'ui-circulatingSupply-12': '',
  'ui-circulatingSupply-16': '',
  'ui-circulatingSupply-24': '',
  'ui-cashAustralianDollar-12': '',
  'ui-cashAustralianDollar-16': '',
  'ui-cashAustralianDollar-24': '',
  'ui-reportInactive-12': '',
  'ui-reportInactive-16': '',
  'ui-reportInactive-24': '',
  'ui-camera-12': '',
  'ui-camera-16': '',
  'ui-camera-24': '',
  'ui-chartLine-12': '',
  'ui-chartLine-16': '',
  'ui-chartLine-24': '',
  'ui-unlock-12': '',
  'ui-unlock-16': '',
  'ui-unlock-24': '',
  'ui-nftSaleInactive-12': '',
  'ui-nftSaleInactive-16': '',
  'ui-nftSaleInactive-24': '',
  'ui-bridging-12': '',
  'ui-bridging-16': '',
  'ui-bridging-24': '',
  'ui-cashJPY-12': '',
  'ui-cashJPY-16': '',
  'ui-cashJPY-24': '',
  'ui-comment-12': '',
  'ui-comment-16': '',
  'ui-comment-24': '',
  'ui-planetInactive-12': '',
  'ui-planetInactive-16': '',
  'ui-planetInactive-24': '',
  'ui-planetActive-12': '',
  'ui-planetActive-16': '',
  'ui-planetActive-24': '',
  'ui-coinbaseOne-12': '',
  'ui-coinbaseOne-16': '',
  'ui-coinbaseOne-24': '',
  'ui-cashSingaporeDollar-12': '',
  'ui-cashSingaporeDollar-16': '',
  'ui-cashSingaporeDollar-24': '',
  'ui-cashCanadianDollar-12': '',
  'ui-cashCanadianDollar-16': '',
  'ui-cashCanadianDollar-24': '',
  'nav-faucet-12-active': '',
  'nav-faucet-12-inactive': '',
  'nav-faucet-16-active': '',
  'nav-faucet-16-inactive': '',
  'nav-faucet-24-active': '',
  'nav-faucet-24-inactive': '',
  'ui-passport-12': '',
  'ui-passport-16': '',
  'ui-passport-24': '',
  'nav-derivatives-12-active': '',
  'nav-derivatives-12-inactive': '',
  'nav-derivatives-16-active': '',
  'nav-derivatives-16-inactive': '',
  'nav-derivatives-24-active': '',
  'nav-derivatives-24-inactive': '',
  'nav-base-12-active': '',
  'nav-base-12-inactive': '',
  'nav-base-16-active': '',
  'nav-base-16-inactive': '',
  'nav-base-24-active': '',
  'nav-base-24-inactive': '',
  'nav-eventContracts-12-active': '',
  'nav-eventContracts-12-inactive': '',
  'nav-eventContracts-16-active': '',
  'nav-eventContracts-16-inactive': '',
  'nav-eventContracts-24-active': '',
  'nav-eventContracts-24-inactive': '',
  'nav-perpetualSwap-12-active': '',
  'nav-perpetualSwap-12-inactive': '',
  'nav-perpetualSwap-16-active': '',
  'nav-perpetualSwap-16-inactive': '',
  'nav-perpetualSwap-24-active': '',
  'nav-perpetualSwap-24-inactive': '',
  'nav-rollingSpot-12-active': '',
  'nav-rollingSpot-12-inactive': '',
  'nav-rollingSpot-16-active': '',
  'nav-rollingSpot-16-inactive': '',
  'nav-rollingSpot-24-active': '',
  'nav-rollingSpot-24-inactive': '',
  'nav-folderArrow-12-active': '',
  'nav-folderArrow-12-inactive': '',
  'nav-folderArrow-16-active': '',
  'nav-folderArrow-16-inactive': '',
  'nav-folderArrow-24-active': '',
  'nav-folderArrow-24-inactive': '',
  'nav-folder-12-active': '',
  'nav-folder-12-inactive': '',
  'nav-folder-16-active': '',
  'nav-folder-16-inactive': '',
  'nav-folder-24-active': '',
  'nav-folder-24-inactive': '',
  'nav-globe-12-active': '',
  'nav-globe-12-inactive': '',
  'nav-globe-16-active': '',
  'nav-globe-16-inactive': '',
  'nav-globe-24-active': '',
  'nav-globe-24-inactive': '',
  'nav-regulatedFutures-12-active': '',
  'nav-regulatedFutures-12-inactive': '',
  'nav-regulatedFutures-16-active': '',
  'nav-regulatedFutures-16-inactive': '',
  'nav-regulatedFutures-24-active': '',
  'nav-regulatedFutures-24-inactive': '',
  'nav-options-12-active': '',
  'nav-options-12-inactive': '',
  'nav-options-16-active': '',
  'nav-options-16-inactive': '',
  'nav-options-24-active': '',
  'nav-options-24-inactive': '',
  'nav-compass-12-active': '',
  'nav-compass-12-inactive': '',
  'nav-compass-16-active': '',
  'nav-compass-16-inactive': '',
  'nav-compass-24-active': '',
  'nav-compass-24-inactive': '',
  'ui-sortDoubleArrow-12': '',
  'ui-sortDoubleArrow-16': '',
  'ui-sortDoubleArrow-24': '',
  'nav-walletLogo-12-active': '',
  'nav-walletLogo-12-inactive': '',
  'nav-walletLogo-16-active': '',
  'nav-walletLogo-16-inactive': '',
  'nav-walletLogo-24-active': '',
  'nav-walletLogo-24-inactive': '',
  'nav-commerceProduct-12-active': '',
  'nav-commerceProduct-12-inactive': '',
  'nav-commerceProduct-16-active': '',
  'nav-commerceProduct-16-inactive': '',
  'nav-commerceProduct-24-active': '',
  'nav-commerceProduct-24-inactive': '',
  'nav-key-12-active': '',
  'nav-key-12-inactive': '',
  'nav-key-16-active': '',
  'nav-key-16-inactive': '',
  'nav-key-24-active': '',
  'nav-key-24-inactive': '',
  'nav-gasFees-12-active': '',
  'nav-gasFees-12-inactive': '',
  'nav-gasFees-16-active': '',
  'nav-gasFees-16-inactive': '',
  'nav-gasFees-24-active': '',
  'nav-gasFees-24-inactive': '',
  'nav-securityKey-12-active': '',
  'nav-securityKey-12-inactive': '',
  'nav-securityKey-16-active': '',
  'nav-securityKey-16-inactive': '',
  'nav-securityKey-24-active': '',
  'nav-securityKey-24-inactive': '',
  'nav-waasProduct-12-active': '',
  'nav-waasProduct-12-inactive': '',
  'nav-waasProduct-16-active': '',
  'nav-waasProduct-16-inactive': '',
  'nav-waasProduct-24-active': '',
  'nav-waasProduct-24-inactive': '',
  'nav-signinProduct-12-active': '',
  'nav-signinProduct-12-inactive': '',
  'nav-signinProduct-16-active': '',
  'nav-signinProduct-16-inactive': '',
  'nav-signinProduct-24-active': '',
  'nav-signinProduct-24-inactive': '',
  'nav-rosettaProduct-12-active': '',
  'nav-rosettaProduct-12-inactive': '',
  'nav-rosettaProduct-16-active': '',
  'nav-rosettaProduct-16-inactive': '',
  'nav-rosettaProduct-24-active': '',
  'nav-rosettaProduct-24-inactive': '',
  'nav-exchangeProduct-12-active': '',
  'nav-exchangeProduct-12-inactive': '',
  'nav-exchangeProduct-16-active': '',
  'nav-exchangeProduct-16-inactive': '',
  'nav-exchangeProduct-24-active': '',
  'nav-exchangeProduct-24-inactive': '',
  'nav-primePoduct-12-active': '',
  'nav-primePoduct-12-inactive': '',
  'nav-primePoduct-16-active': '',
  'nav-primePoduct-16-inactive': '',
  'nav-primePoduct-24-active': '',
  'nav-primePoduct-24-inactive': '',
  'nav-advancedTradeProduct-12-active': '',
  'nav-advancedTradeProduct-12-inactive': '',
  'nav-advancedTradeProduct-16-active': '',
  'nav-advancedTradeProduct-16-inactive': '',
  'nav-advancedTradeProduct-24-active': '',
  'nav-advancedTradeProduct-24-inactive': '',
  'nav-payProduct-12-active': '',
  'nav-payProduct-12-inactive': '',
  'nav-payProduct-16-active': '',
  'nav-payProduct-16-inactive': '',
  'nav-payProduct-24-active': '',
  'nav-payProduct-24-inactive': '',
  'nav-staking-12-active': '',
  'nav-staking-12-inactive': '',
  'nav-staking-16-active': '',
  'nav-staking-16-inactive': '',
  'nav-staking-24-active': '',
  'nav-staking-24-inactive': '',
  'nav-coinbase-12-active': '',
  'nav-coinbase-12-inactive': '',
  'nav-coinbase-16-active': '',
  'nav-coinbase-16-inactive': '',
  'nav-coinbase-24-active': '',
  'nav-coinbase-24-inactive': '',
  'nav-nodeProduct-12-active': '',
  'nav-nodeProduct-12-inactive': '',
  'nav-nodeProduct-16-active': '',
  'nav-nodeProduct-16-inactive': '',
  'nav-nodeProduct-24-active': '',
  'nav-nodeProduct-24-inactive': '',
  'nav-walletProduct-12-active': '',
  'nav-walletProduct-12-inactive': '',
  'nav-walletProduct-16-active': '',
  'nav-walletProduct-16-inactive': '',
  'nav-walletProduct-24-active': '',
  'nav-walletProduct-24-inactive': '',
  'nav-coinbaseCardProduct-12-active': '',
  'nav-coinbaseCardProduct-12-inactive': '',
  'nav-coinbaseCardProduct-16-active': '',
  'nav-coinbaseCardProduct-16-inactive': '',
  'nav-coinbaseCardProduct-24-active': '',
  'nav-coinbaseCardProduct-24-inactive': '',
  'nav-custodyProduct-12-active': '',
  'nav-custodyProduct-12-inactive': '',
  'nav-custodyProduct-16-active': '',
  'nav-custodyProduct-16-inactive': '',
  'nav-custodyProduct-24-active': '',
  'nav-custodyProduct-24-inactive': '',
  'nav-learningRewardsProduct-12-active': '',
  'nav-learningRewardsProduct-12-inactive': '',
  'nav-learningRewardsProduct-16-active': '',
  'nav-learningRewardsProduct-16-inactive': '',
  'nav-learningRewardsProduct-24-active': '',
  'nav-learningRewardsProduct-24-inactive': '',
  'nav-rewardsProduct-12-active': '',
  'nav-rewardsProduct-12-inactive': '',
  'nav-rewardsProduct-16-active': '',
  'nav-rewardsProduct-16-inactive': '',
  'nav-rewardsProduct-24-active': '',
  'nav-rewardsProduct-24-inactive': '',
  'nav-venturesProduct-12-active': '',
  'nav-venturesProduct-12-inactive': '',
  'nav-venturesProduct-16-active': '',
  'nav-venturesProduct-16-inactive': '',
  'nav-venturesProduct-24-active': '',
  'nav-venturesProduct-24-inactive': '',
  'nav-assetManagementProduct-12-active': '',
  'nav-assetManagementProduct-12-inactive': '',
  'nav-assetManagementProduct-16-active': '',
  'nav-assetManagementProduct-16-inactive': '',
  'nav-assetManagementProduct-24-active': '',
  'nav-assetManagementProduct-24-inactive': '',
  'nav-helpCenterProduct-12-active': '',
  'nav-helpCenterProduct-12-inactive': '',
  'nav-helpCenterProduct-16-active': '',
  'nav-helpCenterProduct-16-inactive': '',
  'nav-helpCenterProduct-24-active': '',
  'nav-helpCenterProduct-24-inactive': '',
  'nav-institutionalProduct-12-active': '',
  'nav-institutionalProduct-12-inactive': '',
  'nav-institutionalProduct-16-active': '',
  'nav-institutionalProduct-16-inactive': '',
  'nav-institutionalProduct-24-active': '',
  'nav-institutionalProduct-24-inactive': '',
  'nav-complianceProduct-12-active': '',
  'nav-complianceProduct-12-inactive': '',
  'nav-complianceProduct-16-active': '',
  'nav-complianceProduct-16-inactive': '',
  'nav-complianceProduct-24-active': '',
  'nav-complianceProduct-24-inactive': '',
  'nav-delegateProduct-12-active': '',
  'nav-delegateProduct-12-inactive': '',
  'nav-delegateProduct-16-active': '',
  'nav-delegateProduct-16-inactive': '',
  'nav-delegateProduct-24-active': '',
  'nav-delegateProduct-24-inactive': '',
  'nav-cloudProduct-12-active': '',
  'nav-cloudProduct-12-inactive': '',
  'nav-cloudProduct-16-active': '',
  'nav-cloudProduct-16-inactive': '',
  'nav-cloudProduct-24-active': '',
  'nav-cloudProduct-24-inactive': '',
  'nav-assetHubProduct-12-active': '',
  'nav-assetHubProduct-12-inactive': '',
  'nav-assetHubProduct-16-active': '',
  'nav-assetHubProduct-16-inactive': '',
  'nav-assetHubProduct-24-active': '',
  'nav-assetHubProduct-24-inactive': '',
  'nav-privateClientProduct-12-active': '',
  'nav-privateClientProduct-12-inactive': '',
  'nav-privateClientProduct-16-active': '',
  'nav-privateClientProduct-16-inactive': '',
  'nav-privateClientProduct-24-active': '',
  'nav-privateClientProduct-24-inactive': '',
  'nav-participateProduct-12-active': '',
  'nav-participateProduct-12-inactive': '',
  'nav-participateProduct-16-active': '',
  'nav-participateProduct-16-inactive': '',
  'nav-participateProduct-24-active': '',
  'nav-participateProduct-24-inactive': '',
  'nav-earnProduct-12-active': '',
  'nav-earnProduct-12-inactive': '',
  'nav-earnProduct-16-active': '',
  'nav-earnProduct-16-inactive': '',
  'nav-earnProduct-24-active': '',
  'nav-earnProduct-24-inactive': '',
  'nav-nftProduct-12-active': '',
  'nav-nftProduct-12-inactive': '',
  'nav-nftProduct-16-active': '',
  'nav-nftProduct-16-inactive': '',
  'nav-nftProduct-24-active': '',
  'nav-nftProduct-24-inactive': '',
  'nav-dataMarketplaceProduct-12-active': '',
  'nav-dataMarketplaceProduct-12-inactive': '',
  'nav-dataMarketplaceProduct-16-active': '',
  'nav-dataMarketplaceProduct-16-inactive': '',
  'nav-dataMarketplaceProduct-24-active': '',
  'nav-dataMarketplaceProduct-24-inactive': '',
  'nav-derivativesProduct-12-active': '',
  'nav-derivativesProduct-12-inactive': '',
  'nav-derivativesProduct-16-active': '',
  'nav-derivativesProduct-16-inactive': '',
  'nav-derivativesProduct-24-active': '',
  'nav-derivativesProduct-24-inactive': '',
  'nav-proProduct-12-active': '',
  'nav-proProduct-12-inactive': '',
  'nav-proProduct-16-active': '',
  'nav-proProduct-16-inactive': '',
  'nav-proProduct-24-active': '',
  'nav-proProduct-24-inactive': '',
  'ui-support-12': '',
  'ui-support-16': '',
  'ui-support-24': '',
  'nav-helpCenterQuestionMark-12-active': '',
  'nav-helpCenterQuestionMark-12-inactive': '',
  'nav-helpCenterQuestionMark-16-active': '',
  'nav-helpCenterQuestionMark-16-inactive': '',
  'nav-helpCenterQuestionMark-24-active': '',
  'nav-helpCenterQuestionMark-24-inactive': '',
  'ui-gaugeEmpty-12': '',
  'ui-gaugeEmpty-16': '',
  'ui-gaugeEmpty-24': '',
  'ui-gaugeLow-12': '',
  'ui-gaugeLow-16': '',
  'ui-gaugeLow-24': '',
  'ui-gaugeMedium-12': '',
  'ui-gaugeMedium-16': '',
  'ui-gaugeMedium-24': '',
  'nav-cluster-12-active': '',
  'nav-cluster-12-inactive': '',
  'nav-cluster-16-active': '',
  'nav-cluster-16-inactive': '',
  'nav-cluster-24-active': '',
  'nav-cluster-24-inactive': '',
  'nav-borrowProduct-12-active': '',
  'nav-borrowProduct-12-inactive': '',
  'nav-borrowProduct-16-active': '',
  'nav-borrowProduct-16-inactive': '',
  'nav-borrowProduct-24-active': '',
  'nav-borrowProduct-24-inactive': ''
};
module.exports = glyphMap;
//# sourceMappingURL=glyphMap.js.map
